module.exports = __webpack_public_path__ + "static/img/2824_phase_function_Paper_PointsHejduk_Prediction.f9a95a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2824_phase_function_Paper_PointsHejduk_Prediction.png
// module id = nL6b
// module chunks = 0